import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class FlashNewsApi {
  getFlashNews = async (params) => {
    try {
      const response = await api.get("flash-news", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Flash News. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  getFlashNewsById = async (id) => {
    try {
      const response = await api.get(`flash-news/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Fetch Flash News details. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  saveFlashNews = async (data) => {
    try {
      const response = await api.post("flash-news", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Save Flash News. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  updateFlashNews = async (id, data) => {
    try {
      const response = await api.put(`flash-news/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Update Flash News. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  deleteFlashNews = async (id) => {
    try {
      const response = await api.delete(`flash-news/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Delete Flash News. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  toggleFlashNewsStatus = async (id, data) => {
    try {
      const response = await api.put(`flash-news/status/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to Update Flash News Status. Please try again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };
}

const flashNewsApi = new FlashNewsApi();
export default flashNewsApi;

export const {
  getFlashNews,
  getFlashNewsById,
  saveFlashNews,
  updateFlashNews,
  deleteFlashNews,
  toggleFlashNewsStatus,
} = flashNewsApi;